export const SCA_SCORE_MAPPING: Record<number, number> = {
  8: 58,
  9: 58.75,
  10: 59.25,
  11: 60,
  12: 60.75,
  13: 61.25,
  14: 62,
  15: 62.5,
  16: 63.25,
  17: 64,
  18: 64.5,
  19: 65.25,
  20: 66,
  21: 66.5,
  22: 67.25,
  23: 67.75,
  24: 68.5,
  25: 69.25,
  26: 69.75,
  27: 70.5,
  28: 71.25,
  29: 71.75,
  30: 72.5,
  31: 73,
  32: 73.75,
  33: 74.5,
  34: 75,
  35: 75.75,
  36: 76.5,
  37: 77,
  38: 77.75,
  39: 78.25,
  40: 79,
  41: 79.75,
  42: 80.25,
  43: 81,
  44: 81.75,
  45: 82.25,
  46: 83,
  47: 83.5,
  48: 84.25,
  49: 85,
  50: 85.5,
  51: 86.25,
  52: 87,
  53: 87.5,
  54: 88.25,
  55: 88.75,
  56: 89.5,
  57: 90.25,
  58: 90.75,
  59: 91.5,
  60: 92.25,
  61: 92.75,
  62: 93.5,
  63: 94,
  64: 94.75,
  65: 95.5,
  66: 96,
  67: 96.75,
  68: 97.5,
  69: 98,
  70: 98.75,
  71: 99.25,
  72: 100
};

export const getSCAScore = (sum: number): number => {
  // If sum is below 8, return the lowest score (58) or 0? 
  // Based on the mapping starting at 8, we can assume 8 is the min valid sum for this range.
  if (sum < 8) return 58; // or interpolate linearly if needed, but strict mapping requested.
  if (sum > 72) return 100;
  return SCA_SCORE_MAPPING[sum] || sum; // Fallback to sum if missing (shouldn't happen for integers 8-72)
};
